import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SnackBarComponent } from 'src/app/shared/components/snack-bar/snack-bar.component';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
  signinForm: UntypedFormGroup;
  sharedDataContent: any;
  redirectUrl: string;
  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly snackBar: MatSnackBar) { 
    const navigation = this.router.currentNavigation();
    if(navigation && navigation.extras &&  navigation.extras.state) {
      this.redirectUrl = navigation!.extras!.state!.redirectUrl || null;
    }
    this.signinForm = this.fb.group({
      username: ['',[Validators.required, Validators.email]],
      password: ['',Validators.required]
   })
   this.authService.sharedData$.subscribe((res:any)=> {
    if (res) {
      this.sharedDataContent = res;
    }
  })
  }

  ngOnInit() {
    // Intentionally left blank for future initialization logic
  }

  onSignin() {
    if (!this.signinForm.invalid) {
      this.authService.login(this.signinForm.value).subscribe(response => {
        let res: any = response;
        if(res.message == 'Success') {
          this.router.navigate(['/verification'], {
            state: { redirectUrl: this.redirectUrl },
          });
          this.openSnackBar('Login OTP Sent Successfully','success');
        } 
      },
      error => {
        this.openSnackBar(error.error.message,'error');
      })
    }
  }

  openSnackBar(message: string, type: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: `snack-${type}`,
      duration: 10000,
      verticalPosition: 'top',
      horizontalPosition: 'end',
      data: { 
        message: message,
        snackType: type
      }
    })
  }

}
